import styled from "styled-components";

const FONT_STACK = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`;

export const PanelContainer = styled.div`
  min-height: calc(100vh - 130px);
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem 1.25rem 4rem;
  font-family: ${FONT_STACK};
  -webkit-font-smoothing: antialiased;
  /* .App centra todo el texto: el panel va alineado a la izquierda. */
  text-align: left;

  @media (max-width: 1023px) {
    margin-top: 160px;
    padding: 1.25rem 0.75rem 6rem;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;

  h1 {
    font-size: 1.8rem;
    font-weight: 700;
    color: var(--violetaOscuro);
    margin: 0;
    letter-spacing: -0.02em;
  }

  span {
    display: block;
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--grisMedio);
    margin-top: 0.3rem;
  }
`;

export const Tabs = styled.div`
  display: flex;
  gap: 0.4rem;
  margin: 1.5rem 0 1rem;
  border-bottom: 2px solid #e8e4f0;
  flex-wrap: wrap;
`;

export const Tab = styled.button`
  border: none;
  background: none;
  font-family: inherit;
  font-size: 0.95rem;
  font-weight: 600;
  color: ${({ $activa }) => ($activa ? "var(--violetaOscuro)" : "var(--grisMedio)")};
  padding: 0.6rem 1rem;
  cursor: pointer;
  border-bottom: 3px solid ${({ $activa }) => ($activa ? "var(--naranja)" : "transparent")};
  margin-bottom: -2px;

  &:hover {
    color: var(--violetaOscuro);
  }
`;

export const Panel = styled.section`
  background: var(--blanco);
  border-radius: var(--radio);
  box-shadow: var(--sombra);
  padding: 1.25rem;
  margin-bottom: 1.25rem;
`;

export const Filtros = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;

  label {
    display: flex;
    flex-direction: column;
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--grisMedio);
    gap: 0.25rem;
  }

  input,
  select {
    font-family: inherit;
    font-size: 0.9rem;
    padding: 0.45rem 0.6rem;
    border: 1px solid #ddd6e8;
    border-radius: var(--radio);
    background: var(--blanco);
    color: var(--grisOscuro);
    min-width: 150px;
  }
`;

export const Chips = styled.div`
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-top: 0.9rem;
`;

export const Chip = styled.button`
  border: 1px solid ${({ $activo }) => ($activo ? "var(--violetaOscuro)" : "#ddd6e8")};
  background: ${({ $activo }) => ($activo ? "var(--violetaOscuro)" : "var(--blanco)")};
  color: ${({ $activo }) => ($activo ? "var(--blanco)" : "var(--grisOscuro)")};
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  cursor: pointer;
`;

export const Boton = styled.button`
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 0.9rem;
  border-radius: var(--radio);
  cursor: pointer;
  border: 1px solid var(--violetaOscuro);
  background: ${({ $secundario }) => ($secundario ? "var(--blanco)" : "var(--violetaOscuro)")};
  color: ${({ $secundario }) => ($secundario ? "var(--violetaOscuro)" : "var(--blanco)")};

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.75rem;
  margin: 1rem 0;
`;

export const Kpi = styled.div`
  background: var(--blanco);
  border-radius: var(--radio);
  box-shadow: var(--sombra);
  padding: 0.9rem 1rem;

  strong {
    display: block;
    font-size: 1.5rem;
    color: ${({ $color }) => $color || "var(--violetaOscuro)"};
    line-height: 1.2;
  }

  span {
    font-size: 0.78rem;
    font-weight: 600;
    color: var(--grisMedio);
  }
`;

export const TablaWrapper = styled.div`
  overflow-x: auto;
  background: var(--blanco);
  border-radius: var(--radio);
  box-shadow: var(--sombra);
`;

export const Tabla = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: ${({ $min }) => $min || "1100px"};
  font-size: 0.85rem;

  thead {
    background: #f3eefa;
  }

  th {
    text-align: left;
    padding: 0.7rem 0.75rem;
    font-weight: 700;
    color: var(--violetaOscuro);
    white-space: nowrap;
  }

  td {
    padding: 0.65rem 0.75rem;
    border-top: 1px solid #efecf5;
    vertical-align: top;
  }

  tbody tr:hover {
    background: #faf8fd;
  }
`;

export const Vacio = styled.td`
  padding: 2rem;
  text-align: center;
  color: var(--grisMedio);
`;

const COLORES_ESTADO = {
  OK: "#1e7d4f",
  ERROR: "#c0392b",
  INCIERTO: "#b8860b",
  PENDIENTE: "#6c7a91",
  SEGURIDAD: "#c0392b",
  AUDITORIA: "#4c048c",
};

export const Badge = styled.span`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  white-space: nowrap;
  color: ${({ $estado }) => COLORES_ESTADO[$estado] || "var(--grisOscuro)"};
  border: 1px solid currentColor;
`;

export const Aviso = styled.p`
  margin: 0.75rem 0 0;
  font-size: 0.85rem;
  color: ${({ $error }) => ($error ? "#c0392b" : "var(--grisMedio)")};
`;

export const Paginacion = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.75rem;
  font-size: 0.85rem;
  color: var(--grisMedio);
`;

export const Detalle = styled.div`
  text-align: left;
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 4px;

  /* Encabezado: título + estado */
  .cabecera {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
    margin-bottom: 0.25rem;
  }

  h3 {
    margin: 0;
    color: var(--violetaOscuro);
    font-size: 1.15rem;
  }

  .sub {
    color: var(--grisMedio);
    font-size: 0.8rem;
    margin: 0 0 1rem;
  }

  /* Título de sección */
  h4 {
    margin: 1.1rem 0 0.5rem;
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--grisMedio);
    border-bottom: 1px solid #efecf5;
    padding-bottom: 0.3rem;
  }

  /* Grilla de campos */
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 0.6rem;
  }

  .campo {
    background: #faf8fd;
    border: 1px solid #efecf5;
    border-radius: var(--radio);
    padding: 0.5rem 0.7rem;
  }

  /* Un campo que ocupa toda la fila (domicilio, plan) */
  .campo.ancho {
    grid-column: 1 / -1;
  }

  .campo .k {
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: var(--grisMedio);
    margin-bottom: 0.15rem;
  }

  .campo .v {
    font-size: 0.9rem;
    color: var(--grisOscuro);
    word-break: break-word;
    line-height: 1.35;
  }

  /* Datos técnicos plegables */
  details {
    margin-top: 1.1rem;
    border-top: 1px solid #efecf5;
    padding-top: 0.6rem;
  }

  summary {
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--violetaOscuro);
    list-style: none;
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary::before {
    content: "▸ ";
  }

  details[open] summary::before {
    content: "▾ ";
  }

  pre {
    background: var(--gris);
    padding: 0.75rem;
    border-radius: var(--radio);
    font-size: 0.72rem;
    overflow-x: auto;
    white-space: pre-wrap;
    word-break: break-word;
    margin: 0.5rem 0 0;
  }

  pre + h5 {
    margin: 0.9rem 0 0;
    font-size: 0.72rem;
    color: var(--grisMedio);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
`;

export const FilaConfig = styled.form`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  align-items: flex-end;
  margin-top: 0.9rem;

  input,
  select {
    font-family: inherit;
    font-size: 0.9rem;
    padding: 0.45rem 0.6rem;
    border: 1px solid #ddd6e8;
    border-radius: var(--radio);
    min-width: 170px;
    background-color: white;
  }
`;
